<template>
    <div class="auth">
        <div class="container">
            <div class="auth--box">
                <div class="auth--box--header">
                    <h2 class="auth--title">{{$t('login as operator')}}</h2>
                </div>
                <form>
                    <div :class="{'form--group':true,'form--error':showValidMessage&&errors.has('email')}">
                        <input v-on:keyup.enter="login" class="form--control" type="text" :placeholder="$t('userOrEmail')" id="email" name="email" v-model="model.username" v-validate="'required'" maxlength="50">
                        <p v-show="showValidMessage&&errors.has('email')" class="form--error-text">{{ errors.first('email') }}</p>
                    </div>
            <div :class="{'form--group':true,'form--error':showValidMessage&&errors.has('password')}">
                <input v-on:keyup.enter="login" class="form--control" type="password" :placeholder="$t('Password')" id="password" name="password" v-model="model.password" v-validate="'required'" maxlength="50">
                <p v-show="showValidMessage&&errors.has('password')" class="form--error-text">{{ errors.first('password') }}</p>
            </div>
            <div class="form--group">
                <input class="form-check-input" id="remember-check3" type="checkbox" v-model="rememberme">
                <label class="form-check-label" for="remember-check3">{{$t('Remember me')}}</label>
            </div>
            <button class="btn-round auth-btn" type="button" @click="login">{{$t('Login')}}</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    import GlobalMixin from '@/GlobalMixin.js'    
    import { mapActions } from "vuex";

    export default {
        mixins: [GlobalMixin],
        components: {   },
        data() {
            return {
                    
            }
        },
        methods: {
            ...mapActions(["StoreUser"]),
            login() {
                var self = this;
                self.showValidMessage = true;
                if(self.rememberme)
                    {
                        localStorage.username = self.model.username;
                        localStorage.rememberme = true;
                    }
                    else
                    {
                        localStorage.username = "";
                        localStorage.rememberme = "";
                    }
                let valid = self.customValidate();
                self.$validator.validate().then(function (result) {
                    if (!result || !valid) { ////not valid
                        let detail = $('.form--error').first()[0];
                        if (detail) {
                            detail.scrollIntoView({ behavior: 'smooth', block: 'end' });
                        }
                        return;
                    }
                    $('.form--error').removeClass("form--error");
                    self.closeErrorAlert();
                    self.ShowLoading();
                    self.model.user_type = "operator";
                    let url = process.env.VUE_APP_APIEndPoint +'auth/token/'
                    self.axios.post(url, self.model, self.headers)
                        .then(function (res) {
                            if (res.data.success) {
                                self.model = {};
                                //localStorage.token_data = res.data.token_data;
                                //localStorage.user = res.data.user;
                                //self.headers.headers.Authorization = "Bearer " + res.data.token_data.access_token                                
                                self.notify(self.$t('login success'), "success");
                                self.StoreUser(res.data);
                                //alert(self.$store.getters.isAuthenticated);
                                self.$router.push({ name: 'ApprovedTutors' });
                            }
                            else {
                                self.notify(self.$t(res.data.Messages[0].Message), "error");
                            }
                        })
                        .catch(function (err) {
                            self.displayError(err);
                        }).finally(function () {
                            return self.HideLoading();
                        })
                })
            },
            AfterMountedFn()
            {  
                let self=this;
                if(self.rememberme=="true")
                {
                    self.model.username=localStorage.username
                }
            }

        }
    }
</script>
<style scoped lang="scss">
    .auth--box {
    border: 3px solid var(--auth-second-color);
    }
    .btn-round.auth-btn {
    background: var(--auth-second-color);
    &:hover{
    background: var(--auth-second-color-hover);
    } 
}
.form-check-input:checked {
    background-color: var(--auth-second-color);
    border-color: var(--auth-second-color);
}
.form-check-input:checked+.form-check-label {
    color: var(--auth-second-color);
}
</style>
<style lang="scss">
:root{
  --auth-second-color: #0180D8;
  --auth-second-color-hover: #005c9e;
}
</style>